/**
 * Badge text for university cards.
 *
 * Returns the university's short_name as-is (preserving diacritics and case)
 * so badges read correctly:
 *   UEM, UJC, UP, ISCAM, ISCISA, UniZambeze, UniLúrio, UniPúnguè, UniRovuma,
 *   UniLicungo.
 *
 * The badge element must be a pill / auto-width chip (not a fixed square) so
 * longer names like "UniLicungo" don't get clipped. See UniversitiesPage +
 * CoursesPage + OnboardingPage where the helper is consumed.
 */
export function universityBadge(short_name: string | null | undefined): string {
  if (!short_name) return '??'
  return short_name.trim()
}
